import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';

export function LeaderboardPanel() {
  const [selectedGame, setSelectedGame] = useState('memory');
  const [_period, _setPeriod] = useState('all');

  const { data: gameTypes } = useQuery({
    queryKey: ['game-types'],
    queryFn: () => api.getGameTypes(),
  });

  const { data: leaderboard } = useQuery({
    queryKey: ['leaderboard', selectedGame],
    queryFn: () => api.getLeaderboard(selectedGame),
  });

  const games = (gameTypes as { game_types?: Array<{ id: string; name: string }> })?.game_types || [];
  const scores = (leaderboard as { leaderboard?: Array<{ display_name?: string; achieved_at: number; score?: number }> })?.leaderboard || [];

  return (
    <div className="space-y-6">
      {/* Game Selector */}
      <div className="card">
        <div className="flex gap-3 flex-wrap">
          {games.map((game) => (
            <button
              key={game.id}
              onClick={() => setSelectedGame(game.id)}
              className={`px-3 py-2 rounded-lg text-sm transition-colors ${
                selectedGame === game.id
                  ? 'bg-mars-500 text-white'
                  : 'bg-lunar-700 text-lunar-300 hover:bg-lunar-600'
              }`}
            >
              {game.name}
            </button>
          ))}
        </div>
      </div>

      {/* Leaderboard */}
      <div className="card">
        <h2 className="text-lg font-bold mb-4">
          🏆 {games.find((g) => g.id === selectedGame)?.name || selectedGame} Leaderboard
        </h2>
        
        <div className="space-y-2">
          {scores.map((entry, index) => (
            <div
              key={index}
              className={`flex items-center gap-4 p-3 rounded-lg ${
                index === 0 ? 'bg-yellow-900/30 border border-yellow-700' :
                index === 1 ? 'bg-gray-700/30 border border-gray-600' :
                index === 2 ? 'bg-orange-900/30 border border-orange-700' :
                'bg-lunar-700'
              }`}
            >
              <div className="w-8 text-center font-bold text-lg">
                {index === 0 ? '🥇' :
                 index === 1 ? '🥈' :
                 index === 2 ? '🥉' :
                 `#${index + 1}`}
              </div>
              
              <div className="flex-1">
                <div className="font-medium">{entry.display_name || 'Unknown'}</div>
                <div className="text-xs text-lunar-400">
                  {new Date(entry.achieved_at * 1000).toLocaleDateString()}
                </div>
              </div>
              
              <div className="text-right">
                <div className="text-xl font-bold text-mars-400">
                  {entry.score?.toLocaleString()}
                </div>
                <div className="text-xs text-lunar-400">points</div>
              </div>
            </div>
          ))}
          
          {scores.length === 0 && (
            <div className="text-center text-lunar-400 py-8">
              No scores yet. Be the first!
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
